import React from 'react';
import Books from '../Books/Books';
import Advertise from './Advertise/Advertise';
import Banner from './Banner/Banner';
import Catagories from './Catagories/Catagories';
import Services from './services/Services';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <Advertise></Advertise>
            <Catagories></Catagories>
            <Services></Services>
        </div>
    );
};

export default Home;